import React from 'react';

import Section from '@hero/ui-kit/layout/Section';
import P from '@hero/ui-kit/typography/P';
import Loading from '../../../../../../components/States/Loading';
import * as Style from './style.module.scss';

type Props = {
    title: string;
    meta?: string;
    action?: React.ReactNode;
    /** Full-bleed region between the header and the padded body, e.g. an inline form. */
    banner?: React.ReactNode;
    description?: string;
    isEmpty?: boolean;
    emptyMessage?: string;
    /** Cards fed by their own query; prevents an empty-state flash while fetching. */
    isLoading?: boolean;
    children: React.ReactNode;
};

const EhrCard: React.FC<Props> = ({
    title,
    meta,
    action,
    banner,
    description,
    isEmpty = false,
    emptyMessage,
    isLoading = false,
    children
}) => (
    <Section border noDefaultPadding className={Style.card}>
        <div className={Style.header}>
            <strong className={Style.title}>{title}</strong>

            <div className={Style.headerAside}>
                {meta ? <span className={Style.meta}>{meta}</span> : null}
                {action}
            </div>
        </div>

        {banner}

        <div className={Style.body}>
            {description ? (
                <P size="small" noDefaultMargin className={Style.description}>
                    {description}
                </P>
            ) : null}

            {isLoading ? (
                <Loading height={8} />
            ) : isEmpty ? (
                <P noDefaultMargin className={Style.empty}>
                    {emptyMessage}
                </P>
            ) : (
                children
            )}
        </div>
    </Section>
);

export default EhrCard;
